module.exports = __webpack_public_path__ + "img/apple.7a7fe1b6.svg";